export default __webpack_public_path__ + "1f9b9260f7fc9eb0d6d26cd110b25a11.png";